import { useState } from "react";
import api from "../../api";
import AgolCheck from "../ui/AgolCheck";

const DEFAULT_LAYER_ID = "dd252cfcbd7b44cfbeecc6a9370c48d7";

// Run Step: end-of-week cleanup — flip all Upcoming treatment areas to Completed
// so the website iframe (filtered by Status='Upcoming') stops showing them.
export default function ClearTreatmentPanel() {
  const [layerId, setLayerId] = useState(
    localStorage.getItem("pioneer_treatment_layer_id") || DEFAULT_LAYER_ID
  );
  const [state, setState] = useState<"idle" | "busy" | "ok" | "error">("idle");
  const [message, setMessage] = useState("");

  const run = async () => {
    if (!layerId) return;
    setState("busy");
    localStorage.setItem("pioneer_treatment_layer_id", layerId);
    try {
      const res = await api.post("/clear-treatment-schedule", { layer_id: layerId });
      setState("ok");
      setMessage(`Cleared ${res.data.cleared} treatment area${res.data.cleared !== 1 ? "s" : ""} → Completed`);
    } catch (err: any) {
      setState("error");
      setMessage(err?.response?.data?.message || err.message);
    }
  };

  return (
    <div className="space-y-3">
      <AgolCheck layerLabel="Adulticide Treatment Areas 2026" testEndpoint="/get-layer-info" payload={{ layer_id: layerId }} />
      <p className="text-sm text-ink-soft">
        Flips all <b>Upcoming</b> treatment polygons to <b>Completed</b> on the persistent treatment layer.
        The Streamline website filters by <code>Status = 'Upcoming'</code>, so this hides them automatically.
      </p>
      <label className="text-xs font-semibold block">
        Treatment layer item ID
        <input
          value={layerId}
          onChange={(e) => setLayerId(e.target.value)}
          placeholder="AGOL item ID"
          className="mt-1 w-full max-w-md border border-line-strong rounded-sm2 px-2 py-1.5 text-sm font-mono"
        />
      </label>
      <button className="btn-primary" onClick={run} disabled={state === "busy" || !layerId}>
        {state === "busy" ? "Clearing…" : "Clear Treatment Schedule (mark Completed)"}
      </button>
      {state === "ok" && <p className="text-brand-deep text-sm font-semibold">✓ {message}</p>}
      {state === "error" && <p className="text-wnv text-sm font-semibold">✗ {message}</p>}
    </div>
  );
}
